<template>
  <div class="box_ent">
    <div class="enterpriseInformationInfo">
      <div class="name">
        {{list.text}}
      </div>
      <div class="time">
        发表时间：{{list.time}}
      </div>
      <div class="box_ent_info" v-html="list.info"></div>
      <div class="core_top">
        <span @click="black">返回上一页</span>
      </div>
    </div>
  </div>
</template>

<script>
import {enterpriseList} from "@/views/mock";

export default {
  name: "enterpriseInformationInfo",
  data(){
    return{
      list:{}
    }
  },
  created(){
    let arr = enterpriseList.filter((item)=>{
      return item.id == this.$route.query.id
    })
    console.log(arr)
    this.list = arr[0]
  },
  methods:{
    black(){
      window.history.back()
    }
  }
}
</script>

<style scoped lang="scss">
.box_ent{
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px 0;
}
.enterpriseInformationInfo{
  width: 1200px;
  .name{
    font-size: 24px;
    font-weight: bold;
  }
  .time{
    margin-top: 20px;
    color: rgb(107,107,107);
  }
  .box_ent_info{
    margin-top: 20px;
    border-top: 1px solid rgb(217,217,217);
    border-bottom: 1px solid rgb(217,217,217);
    padding: 30px 0;
  }
  .core_top{
    font-size: 14px;
    padding: 14px 0;
    cursor: pointer;
  }
}
</style>
